/*
 *
 * EmbeddedPage reducer
 *
 */

import { fromJS } from 'immutable';

import {
  UPDATE_EMBEDDED_OFFER_THEME,
  UPDATE_SELECTED_CHECKBOX_PRODUCTS,
  UPDATE_EMBEDDED_MR_OFFER_ID,
  UPDATE_EMBEDDED_PRIMARY_PRODUCT,
  UPDATE_PRODUCT_ADD_ONS_WIDGET_ID,
  UPDATE_FIELD,
} from './constants';

export const initialState = fromJS({
  mrOfferID: '',
  primaryProduct: { sp_product_id: 0, sp_variant_id: 0 },
  atcStatus: {
    adding: false,
    added: false,
    spVariantID: 0,
  },
  selectedCheckboxProducts: [],
  theme: {},
  productAddOnsWidgetId: 0,
  discountQuantity: 0,
  offerLevelDiscountQuantity: 0,
  isConsiderRepetetionOfRules: false,
});

function embeddedPageReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTED_CHECKBOX_PRODUCTS:
      return state.set(
        'selectedCheckboxProducts',
        fromJS(action.newSelectedCheckboxProducts),
      );
    case UPDATE_EMBEDDED_OFFER_THEME:
      return state.set('theme', action.updatedTheme);
    case UPDATE_EMBEDDED_MR_OFFER_ID:
      return state.set('mrOfferID', action.updatedMrOfferID);
    case UPDATE_EMBEDDED_PRIMARY_PRODUCT:
      return state.set('primaryProduct', action.updatedPrimaryProduct);
    case UPDATE_PRODUCT_ADD_ONS_WIDGET_ID:
      return state.set('productAddOnsWidgetId', action.widgetID);
    case UPDATE_FIELD:
      return state.set(action.name, action.v);
    default:
      return state;
  }
}

export default embeddedPageReducer;
